import { Component, OnInit } from '@angular/core';
import { IEmployee } from 'ng2-org-chart/src/employee';
import { ContactInformationVipService, EventProjectService, UploadFilesService, CommonService } from 'src/app/shared';
import { environment } from '../../environments/environment';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
declare var jquery: any;
declare var $: any;
declare var Swal: any;
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import * as QRCode from 'qrcode';
import * as moment from 'moment';

export interface PrintCode {
  id?: string;
  code: string;
  effect_date: string;
  expire_date: string;
  usage_limit: number | null;
  usages_count?: number;
}

@Component({
  selector: 'app-event-project',
  templateUrl: './event-project.component.html',
  styleUrls: ['./event-project.component.css']
})
export class EventProjectComponent implements OnInit {

  contactInformationVip = { "name": "", "description": "" };
  addForm: FormGroup;
  editForm: FormGroup;
  submitted_add = false;
  submitted_edit = false;
  currentId;
  fileName = 'Choose file';

  // Payment & Print Code & Subscription
  addPaymentEnabled = false;
  addPrintCodeEnabled = false;
  addPrintCodes: PrintCode[] = [];
  addSubscriptionEnabled = false;
  addSubscriptionUrl = '';
  editPaymentEnabled = false;
  editPrintCodeEnabled = false;
  editPrintCodes: PrintCode[] = [];
  editSubscriptionEnabled = false;
  editSubscriptionUrl = '';

  // --- subscription image (add) ---
  selectedFileSubscription: File | null = null;
  previewUrlSubscription: string | ArrayBuffer | null = null;
  fileNameSubscription = 'Choose file';
  errorMessageSubscription = '';
  errorMessageSubscriptionUrl = '';

  // --- subscription image (edit) ---
  selectedFileSubscriptionEdit: File | null = null;
  previewUrlSubscriptionEdit: string | ArrayBuffer | null = null;
  fileNameSubscriptionEdit = 'Choose file';
  errorMessageSubscriptionEdit = '';
  errorMessageSubscriptionUrlEdit = '';

  // --- payment image (add) ---
  selectedFilePayment: File | null = null;
  previewUrlPayment: string | ArrayBuffer | null = null;
  fileNamePayment = 'Choose file';
  errorMessagePayment = '';

  // --- payment image (edit) ---
  selectedFilePaymentEdit: File | null = null;
  previewUrlPaymentEdit: string | ArrayBuffer | null = null;
  fileNamePaymentEdit = 'Choose file';
  errorMessagePaymentEdit = '';

  selectedFile: File | null = null;
  errorMessage = '';
  previewUrl: string | ArrayBuffer | null = null;

  // --- file_frame_list ---
  selectedFileFrameList: File | null = null;
  previewUrlFrameList: string | ArrayBuffer | null = null;
  fileNameFrameList = 'Choose file';
  useColorFrameList = false;
  selectedColorFrameList = '';
  errorMessageFrameList = '';

  // --- file_frame ---
  selectedFileFrame: File | null = null;
  previewUrlFrame: string | ArrayBuffer | null = null;
  fileNameFrame = 'Choose file';
  useColorFrame = false;
  selectedColorFrame = '';
  errorMessageFrame = '';

  // --- file_finish ---
  selectedFileFinish: File | null = null;
  previewUrlFinish: string | ArrayBuffer | null = null;
  fileNameFinish = 'Choose file';
  useColorFinish = false;
  selectedColorFinish = '';
  errorMessageFinish = '';

  readonly MAX_SIZE = 100 * 1024 * 1024; // 100MB
  readonly MAX_WIDTH = 1920;
  readonly MAX_HEIGHT = 1200;
  readonly QR_IMAGE_SIZE = 1024; // รูป Payment/Subscription ต้องเป็น 1024 x 1024 เท่านั้น
  readonly QR_IMAGE_TYPES = ['image/jpeg', 'image/png', 'image/gif'];

  // แสดง/ซ่อน ตำแหน่งที่ QR Code จะแสดง บน preview
  showQrPreviewPayment = false;
  showQrPreviewPaymentEdit = false;
  showQrPreviewSubscription = false;
  showQrPreviewSubscriptionEdit = false;

  toggleQrPreviewPayment() { this.showQrPreviewPayment = !this.showQrPreviewPayment; }
  toggleQrPreviewPaymentEdit() { this.showQrPreviewPaymentEdit = !this.showQrPreviewPaymentEdit; }
  toggleQrPreviewSubscription() { this.showQrPreviewSubscription = !this.showQrPreviewSubscription; }
  toggleQrPreviewSubscriptionEdit() { this.showQrPreviewSubscriptionEdit = !this.showQrPreviewSubscriptionEdit; }

  /**
   * ตรวจสอบไฟล์รูป QR (Payment/Subscription): ต้องเป็นรูปภาพ ขนาด 1024 x 1024 เท่านั้น
   * คืน Promise<string> เป็นข้อความ error ('' = ผ่าน)
   */
  private validateQrImage(file: File): Promise<string> {
    return new Promise((resolve) => {
      if (!file) { resolve('ไฟล์ไม่ถูกต้อง'); return; }
      if (!this.QR_IMAGE_TYPES.includes(file.type)) {
        resolve('ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) เท่านั้น');
        return;
      }
      if (file.size > this.MAX_SIZE) { resolve('ขนาดไฟล์ต้องไม่เกิน 100 MB'); return; }
      const reader = new FileReader();
      reader.onload = (e: any) => {
        const img = new Image();
        img.onload = () => {
          if (img.width !== this.QR_IMAGE_SIZE || img.height !== this.QR_IMAGE_SIZE) {
            resolve('รูปต้องมีขนาด 1024 x 1024 พิกเซลเท่านั้น (รูปที่เลือกขนาด ' + img.width + ' x ' + img.height + ')');
          } else {
            resolve('');
          }
        };
        img.onerror = () => resolve('ไม่สามารถอ่านรูปภาพได้');
        img.src = e.target.result;
      };
      reader.onerror = () => resolve('ไม่สามารถอ่านไฟล์ได้');
      reader.readAsDataURL(file);
    });
  }
  readonly ALLOWED_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'video/mp4', 'video/webm', 'video/ogg'];
  readonly COLOR_OPTIONS = ['BLUE', 'BLACK', 'RED', 'WHITE', 'GREEN', 'YELLOW'];
  readonly COLOR_MAP: { [key: string]: string } = {
    BLUE: '#1a73e8',
    BLACK: '#212121',
    RED: '#e53935',
    WHITE: '#f5f5f5',
    GREEN: '#43a047',
    YELLOW: '#fdd835'
  };

  constructor(
    private fb: FormBuilder,
    private uploadService: UploadFilesService,
    private eventProjectService: EventProjectService,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private contactInformationVipService: ContactInformationVipService,
    private router: Router
  ) {
    this.addForm = fb.group({
      'name': ['', Validators.required],
      'description': [''],
      'effect_expire_date': ['', Validators.required],
      'effect_date': ['', Validators.required],
      'expire_date': ['', Validators.required],
      'file': ['', Validators.required],
      'file_frame_list': [''],
      'file_frame': [''],
      'file_finish': [''],
      'photos_per_payment': [1, [Validators.min(1)]],
    });

    this.editForm = fb.group({
      'name': ['', Validators.required],
      'description': [''],
      'effect_expire_date': ['', Validators.required],
      'effect_date': ['', Validators.required],
      'expire_date': ['', Validators.required],
      'file': [''],
      'file_frame_list': [''],
      'file_frame': [''],
      'file_finish': [''],
      'photos_per_payment': [1, [Validators.min(1)]],
      'id': ['', Validators.required]
    });
  }

  ngOnInit() {
    this.getAll();
  }

  eventProjectList;
  originalOrder;
  orderChanged = false;
  dragIndex: number = null;
  dragOverIndex: number = null;

  onDragStart(index: number) {
    this.dragIndex = index;
  }

  onDragOver(event: DragEvent, index: number) {
    event.preventDefault();
    this.dragOverIndex = index;
  }

  onDrop(index: number) {
    if (this.dragIndex === null || this.dragIndex === index) return;
    const item = this.eventProjectList.splice(this.dragIndex, 1)[0];
    this.eventProjectList.splice(index, 0, item);
    this.orderChanged = true;
    this.dragIndex = null;
    this.dragOverIndex = null;
  }

  onDragEnd() {
    this.dragIndex = null;
    this.dragOverIndex = null;
  }

  saveOrder() {
    const orders = this.eventProjectList.map((item, i) => ({ id: item.id, sort_order: i }));
    this.spinner.show();
    this.eventProjectService.updateOrder(orders).subscribe(() => {
      this.spinner.hide();
      this.orderChanged = false;
      this.originalOrder = [...this.eventProjectList];
      this.successDialog();
    }, err => {
      this.spinner.hide();
      this.failDialog('');
    });
  }

  cancelOrder() {
    this.eventProjectList = [...this.originalOrder];
    this.orderChanged = false;
  }

  getAll() {
    this.spinner.show();
    this.eventProjectList = [];
    this.eventProjectService.getAll().subscribe(data => {
      this.eventProjectList = data;
      this.eventProjectList.forEach(data => {
        data["url"] = environment.api_domain + "/api/v1/files-view/" + data.file_manager_id;
      });
      this.originalOrder = [...this.eventProjectList];
      this.orderChanged = false;
      console.log(data);
      this.spinner.hide();
    }, err => {
      this.spinner.hide();
      console.log(err);
    });
  }

  toggleAddPayment() {
    this.addPaymentEnabled = !this.addPaymentEnabled;
    if (this.addPaymentEnabled) {
      this.addForm.controls.photos_per_payment.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.addForm.controls.photos_per_payment.clearValidators();
    }
    this.addForm.controls.photos_per_payment.updateValueAndValidity();
  }

  toggleAddPrintCode() {
    this.addPrintCodeEnabled = !this.addPrintCodeEnabled;
  }

  toggleAddSubscription() {
    this.addSubscriptionEnabled = !this.addSubscriptionEnabled;
  }

  toggleAddSelectAll() {
    const enableAll = !(this.addPaymentEnabled && this.addPrintCodeEnabled && this.addSubscriptionEnabled);
    this.addPaymentEnabled = enableAll;
    this.addPrintCodeEnabled = enableAll;
    this.addSubscriptionEnabled = enableAll;
    if (enableAll) {
      this.addForm.controls.photos_per_payment.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.addForm.controls.photos_per_payment.clearValidators();
    }
    this.addForm.controls.photos_per_payment.updateValueAndValidity();
  }

  toggleEditPayment() {
    this.editPaymentEnabled = !this.editPaymentEnabled;
    if (this.editPaymentEnabled) {
      this.editForm.controls.photos_per_payment.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.editForm.controls.photos_per_payment.clearValidators();
    }
    this.editForm.controls.photos_per_payment.updateValueAndValidity();
  }

  toggleEditPrintCode() {
    this.editPrintCodeEnabled = !this.editPrintCodeEnabled;
  }

  toggleEditSubscription() {
    this.editSubscriptionEnabled = !this.editSubscriptionEnabled;
  }

  toggleEditSelectAll() {
    const enableAll = !(this.editPaymentEnabled && this.editPrintCodeEnabled && this.editSubscriptionEnabled);
    this.editPaymentEnabled = enableAll;
    this.editPrintCodeEnabled = enableAll;
    this.editSubscriptionEnabled = enableAll;
    if (enableAll) {
      this.editForm.controls.photos_per_payment.setValidators([Validators.required, Validators.min(1)]);
    } else {
      this.editForm.controls.photos_per_payment.clearValidators();
    }
    this.editForm.controls.photos_per_payment.updateValueAndValidity();
  }

  onPrintCodeInput(event: any, item: PrintCode) {
    const val = event.target.value.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    item.code = val;
    event.target.value = val;
  }

  addPrintCodeItem(list: PrintCode[]) {
    list.push({ code: '', effect_date: '', expire_date: '', usage_limit: null });
  }

  removePrintCodeItem(list: PrintCode[], index: number) {
    list.splice(index, 1);
  }

  // เปิดแท็บใหม่ไปหน้ารายการที่ใช้รหัสนี้ (แสดงในหน้า list-photos โหมด "รหัสที่ใช้")
  viewPrintCodeUsages(item: PrintCode) {
    if (!item || !item.id) { return; }
    // ใช้ hash routing (#/list-photos) ตามที่ระบบตั้งค่า useHash: true
    const tree = this.router.createUrlTree(['/list-photos'], {
      queryParams: { print_code_id: item.id, code: item.code }
    });
    const url = '#' + this.router.serializeUrl(tree);
    window.open(url, '_blank');
  }

  openCreate() {
    this.fileName = 'Choose file';
    this.selectedFile = null;
    this.errorMessage = '';
    this.previewUrl = null;
    this.addPaymentEnabled = false;
    this.addPrintCodeEnabled = false;
    this.addPrintCodes = [];
    this.addSubscriptionEnabled = false;
    this.addSubscriptionUrl = '';
    this.selectedFileSubscription = null;
    this.previewUrlSubscription = null;
    this.fileNameSubscription = 'Choose file';
    this.errorMessageSubscription = '';
    this.selectedFilePayment = null;
    this.previewUrlPayment = null;
    this.fileNamePayment = 'Choose file';
    this.errorMessagePayment = '';
    this.showQrPreviewPayment = false;
    this.showQrPreviewSubscription = false;

    // reset file_frame_list
    this.selectedFileFrameList = null;
    this.previewUrlFrameList = null;
    this.fileNameFrameList = 'Choose file';
    this.useColorFrameList = false;
    this.selectedColorFrameList = '';
    this.errorMessageFrameList = '';

    // reset file_frame
    this.selectedFileFrame = null;
    this.previewUrlFrame = null;
    this.fileNameFrame = 'Choose file';
    this.useColorFrame = false;
    this.selectedColorFrame = '';
    this.errorMessageFrame = '';

    // reset file_finish
    this.selectedFileFinish = null;
    this.previewUrlFinish = null;
    this.fileNameFinish = 'Choose file';
    this.useColorFinish = false;
    this.selectedColorFinish = '';
    this.errorMessageFinish = '';

    this.addForm.patchValue({
      name: "",
      description: "",
      effect_expire_date: this.commonService.convertDateToStrng(new Date()) + " - " + this.commonService.convertDateToStrng(new Date()),
      effect_date: this.commonService.convertDateToStrng(new Date()),
      expire_date: this.commonService.convertDateToStrng(new Date()),
      file: null,
    });

    $('#modal-create').modal({
      backdrop: 'static',
      keyboard: false
    }).modal('show');
  }

  daterange: any = {};
  startDate;
  endDate;
  options: any = {
    locale: { format: 'DD-MM-YYYY' },
    alwaysShowCalendars: false,
  };

  selectedDateAdd(value: any, datepicker?: any) {
    console.log(value);
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = value.start._d;
    this.endDate = value.end._d;
    this.addForm.patchValue({
      effect_expire_date: this.commonService.convertDateToStrng(this.startDate) + " - " + this.commonService.convertDateToStrng(this.endDate),
      effect_date: this.commonService.convertDateToStrng(this.startDate),
      expire_date: this.commonService.convertDateToStrng(this.endDate)
    });
  }

  selectedDateEdit(value: any, datepicker?: any) {
    console.log(value);
    datepicker.start = value.start;
    datepicker.end = value.end;
    this.startDate = value.start._d;
    this.endDate = value.end._d;
    this.editForm.patchValue({
      effect_expire_date: this.commonService.convertDateToStrng(this.startDate) + " - " + this.commonService.convertDateToStrng(this.endDate),
      effect_date: this.commonService.convertDateToStrng(this.startDate),
      expire_date: this.commonService.convertDateToStrng(this.endDate)
    });
  }

  // ==================== Main file ====================
  previewIsVideo = false;
  onFileSelected(event: any) {
    this.errorMessage = '';
    this.previewUrl = null;

    const file: File = event.target.files[0];
    if (!file) {
      this.errorMessage = 'ไฟล์ไม่ถูกต้อง';
      this.selectedFile = null;
      this.previewUrl   = null;
      this.previewIsVideo = false;
      return;
    }

    // validate type
    if (!this.ALLOWED_TYPES.includes(file.type)) {
      this.errorMessage = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) หรือวิดีโอ (MP4, WEBM, OGG)';
      this.selectedFile = null;
      this.previewUrl   = null;
      this.previewIsVideo = false;
      return;
    }

    // validate size
    if (file.size > this.MAX_SIZE) {
      this.errorMessage = 'ขนาดไฟล์ต้องไม่เกิน 100 MB';
      return;
    }

    this.previewIsVideo = file.type.indexOf('video/') === 0;

    this.fileName       = file.name;
    this.selectedFile   = file;

    const reader = new FileReader();
    reader.onload = (e: any) => { this.previewUrl = e.target.result; };
    reader.readAsDataURL(file);

    // const reader = new FileReader();
    // reader.onload = (e: any) => {
    //   const img = new Image();
    //   img.onload = () => {
    //     this.selectedFile = file;
    //     this.previewUrl = e.target.result;
    //   };
    //   img.src = e.target.result;
    // };
    // reader.readAsDataURL(file);
  }

  // ==================== file_frame_list ====================
  toggleColorModeFrameList(useColor: boolean) {
    this.useColorFrameList = useColor;
    this.selectedFileFrameList = null;
    this.previewUrlFrameList = null;
    this.fileNameFrameList = 'Choose file';
    this.selectedColorFrameList = '';
    this.errorMessageFrameList = '';
  }

  onFileSelectedFrameList(event: any) {
    this.errorMessageFrameList = '';
    this.previewUrlFrameList = null;
    const file: File = event.target.files[0];
    if (!file) { this.errorMessageFrameList = 'ไฟล์ไม่ถูกต้อง'; return; }
    if (!this.ALLOWED_TYPES.includes(file.type)) { this.errorMessageFrameList = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) หรือวิดีโอ (MP4, WEBM, OGG)'; return; }
    if (file.size > this.MAX_SIZE) { this.errorMessageFrameList = 'ขนาดไฟล์ต้องไม่เกิน 100 MB'; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFileFrameList = file;
      this.previewUrlFrameList = e.target.result;
      this.fileNameFrameList = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== file_frame ====================
  toggleColorModeFrame(useColor: boolean) {
    this.useColorFrame = useColor;
    this.selectedFileFrame = null;
    this.previewUrlFrame = null;
    this.fileNameFrame = 'Choose file';
    this.selectedColorFrame = '';
    this.errorMessageFrame = '';
  }

  onFileSelectedFrame(event: any) {
    this.errorMessageFrame = '';
    this.previewUrlFrame = null;
    const file: File = event.target.files[0];
    if (!file) { this.errorMessageFrame = 'ไฟล์ไม่ถูกต้อง'; return; }
    if (!this.ALLOWED_TYPES.includes(file.type)) { this.errorMessageFrame = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) หรือวิดีโอ (MP4, WEBM, OGG)'; return; }
    if (file.size > this.MAX_SIZE) { this.errorMessageFrame = 'ขนาดไฟล์ต้องไม่เกิน 100 MB'; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFileFrame = file;
      this.previewUrlFrame = e.target.result;
      this.fileNameFrame = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== file_finish ====================
  toggleColorModeFinish(useColor: boolean) {
    this.useColorFinish = useColor;
    this.selectedFileFinish = null;
    this.previewUrlFinish = null;
    this.fileNameFinish = 'Choose file';
    this.selectedColorFinish = '';
    this.errorMessageFinish = '';
  }

  onFileSelectedFinish(event: any) {
    this.errorMessageFinish = '';
    this.previewUrlFinish = null;
    const file: File = event.target.files[0];
    if (!file) { this.errorMessageFinish = 'ไฟล์ไม่ถูกต้อง'; return; }
    if (!this.ALLOWED_TYPES.includes(file.type)) { this.errorMessageFinish = 'ไฟล์ต้องเป็นรูปภาพ (JPG, PNG, GIF) หรือวิดีโอ (MP4, WEBM, OGG)'; return; }
    if (file.size > this.MAX_SIZE) { this.errorMessageFinish = 'ขนาดไฟล์ต้องไม่เกิน 100 MB'; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFileFinish = file;
      this.previewUrlFinish = e.target.result;
      this.fileNameFinish = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== subscription image (add) ====================
  async onFileSelectedSubscription(event: any) {
    this.errorMessageSubscription = '';
    this.previewUrlSubscription = null;
    this.selectedFileSubscription = null;
    this.fileNameSubscription = 'Choose file';
    const file: File = event.target.files[0];
    const err = await this.validateQrImage(file);
    if (err) { this.errorMessageSubscription = err; event.target.value = ''; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFileSubscription = file;
      this.previewUrlSubscription = e.target.result;
      this.fileNameSubscription = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== subscription image (edit) ====================
  async onFileSelectedSubscriptionEdit(event: any) {
    this.errorMessageSubscriptionEdit = '';
    this.previewUrlSubscriptionEdit = null;
    this.selectedFileSubscriptionEdit = null;
    this.fileNameSubscriptionEdit = 'Choose file';
    const file: File = event.target.files[0];
    const err = await this.validateQrImage(file);
    if (err) { this.errorMessageSubscriptionEdit = err; event.target.value = ''; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFileSubscriptionEdit = file;
      this.previewUrlSubscriptionEdit = e.target.result;
      this.fileNameSubscriptionEdit = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== payment image (add) ====================
  async onFileSelectedPayment(event: any) {
    this.errorMessagePayment = '';
    this.previewUrlPayment = null;
    this.selectedFilePayment = null;
    this.fileNamePayment = 'Choose file';
    const file: File = event.target.files[0];
    const err = await this.validateQrImage(file);
    if (err) { this.errorMessagePayment = err; event.target.value = ''; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFilePayment = file;
      this.previewUrlPayment = e.target.result;
      this.fileNamePayment = file.name;
    };
    reader.readAsDataURL(file);
  }

  // ==================== payment image (edit) ====================
  async onFileSelectedPaymentEdit(event: any) {
    this.errorMessagePaymentEdit = '';
    this.previewUrlPaymentEdit = null;
    this.selectedFilePaymentEdit = null;
    this.fileNamePaymentEdit = 'Choose file';
    const file: File = event.target.files[0];
    const err = await this.validateQrImage(file);
    if (err) { this.errorMessagePaymentEdit = err; event.target.value = ''; return; }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      this.selectedFilePaymentEdit = file;
      this.previewUrlPaymentEdit = e.target.result;
      this.fileNamePaymentEdit = file.name;
    };
    reader.readAsDataURL(file);
  }

  // validate print codes: effect_date < expire_date
  private validatePrintCodes(list: PrintCode[]): string {
    for (let i = 0; i < list.length; i++) {
      const item = list[i];
      if (!item.code) { return `รหัสที่ ${i + 1}: กรุณาระบุรหัส`; }
      if (item.effect_date && item.expire_date && item.effect_date >= item.expire_date) {
        return `รหัสที่ ${i + 1} (${item.code}): วันที่มีผลต้องน้อยกว่าวันหมดอายุ`;
      }
    }
    return '';
  }

  // ==================== Create ====================
  create() {
    console.log(this.addForm.value);
    this.submitted_add = true;
    if (this.addForm.invalid) { return; }

    if (this.addPrintCodeEnabled) {
      const err = this.validatePrintCodes(this.addPrintCodes);
      if (err) { this.failDialog(err); return; }
    }

    this.errorMessageSubscriptionUrl = '';
    if (this.addSubscriptionEnabled && this.addSubscriptionUrl) {
      if (!/^https?:\/\//i.test(this.addSubscriptionUrl)) {
        this.errorMessageSubscriptionUrl = 'URL ต้องขึ้นต้นด้วย http:// หรือ https:// เท่านั้น';
        return;
      }
    }

    const formData = new FormData();
    formData.append('file', this.selectedFile);
    formData.append('name', this.addForm.value.name);
    formData.append('description', this.addForm.value.description);
    formData.append('effect_date', this.addForm.value.effect_date);
    formData.append('expire_date', this.addForm.value.expire_date);
    formData.append('payment_enabled', this.addPaymentEnabled ? '1' : '0');
    formData.append('print_code_enabled', this.addPrintCodeEnabled ? '1' : '0');
    formData.append('subscription_enabled', this.addSubscriptionEnabled ? '1' : '0');
    if (this.addSubscriptionEnabled) {
      if (this.addSubscriptionUrl) {
        formData.append('subscription_url', this.addSubscriptionUrl);
      }
      if (this.selectedFileSubscription) {
        formData.append('file_subscription', this.selectedFileSubscription);
      }
    }
    if (this.addPrintCodeEnabled && this.addPrintCodes.length > 0) {
      formData.append('print_codes', JSON.stringify(this.addPrintCodes));
    }
    if (this.addPaymentEnabled) {
      formData.append('photos_per_payment', this.addForm.value.photos_per_payment);
      if (this.selectedFilePayment) {
        formData.append('file_payment', this.selectedFilePayment);
      }
    }

    // file_frame_list
    if (this.selectedFileFrameList) {
      formData.append('file_frame_list', this.selectedFileFrameList);
    } else if (this.useColorFrameList && this.selectedColorFrameList) {
      formData.append('file_frame_list_color', this.selectedColorFrameList);
    }

    // file_frame
    if (this.selectedFileFrame) {
      formData.append('file_frame', this.selectedFileFrame);
    } else if (this.useColorFrame && this.selectedColorFrame) {
      formData.append('file_frame_color', this.selectedColorFrame);
    }

    // file_finish
    if (this.selectedFileFinish) {
      formData.append('file_finish', this.selectedFileFinish);
    } else if (this.useColorFinish && this.selectedColorFinish) {
      formData.append('file_finish_color', this.selectedColorFinish);
    }

    this.spinner.show();
    this.eventProjectService.create(formData).subscribe(data => {
      this.submitted_add = false;
      this.spinner.hide();
      $('#modal-create').modal('hide');
      this.getAll();
      this.successDialog();
    }, error => {
      console.error(error);
      this.spinner.hide();
      this.failDialog(error.expire_date[0]);
    });
  }

  // ==================== Open Edit ====================
  openEdit(data) {
  this.selectedFile = null;
  this.errorMessage = '';

  // ===== reset frame_list =====
  this.selectedFileFrameList  = null;
  this.previewUrlFrameList    = null;
  this.fileNameFrameList      = 'Choose file';
  this.errorMessageFrameList  = '';
  // โหลดค่าเดิม
  if (data.frame_list_color) {
    // มีสีเดิม → เปิด color mode และเลือกสีเดิมไว้
    this.useColorFrameList      = true;
    this.selectedColorFrameList = data.frame_list_color;
  } else {
    this.useColorFrameList      = false;
    this.selectedColorFrameList = '';
    if (data.frame_list_file_manager_id) {
      this.previewUrlFrameList = environment.api_domain + '/api/v1/files-view/' + data.frame_list_file_manager_id + '?v=' + data.updated_at;
    }
  }

  // ===== reset frame =====
  this.selectedFileFrame  = null;
  this.previewUrlFrame    = null;
  this.fileNameFrame      = 'Choose file';
  this.errorMessageFrame  = '';
  // โหลดค่าเดิม
  if (data.frame_color) {
    this.useColorFrame      = true;
    this.selectedColorFrame = data.frame_color;
  } else {
    this.useColorFrame      = false;
    this.selectedColorFrame = '';
    if (data.frame_file_manager_id) {
      this.previewUrlFrame = environment.api_domain + '/api/v1/files-view/' + data.frame_file_manager_id + '?v=' + data.updated_at;
    }
  }

  // ===== reset finish =====
  this.selectedFileFinish  = null;
  this.previewUrlFinish    = null;
  this.fileNameFinish      = 'Choose file';
  this.errorMessageFinish  = '';
  // โหลดค่าเดิม
  if (data.finish_color) {
    this.useColorFinish      = true;
    this.selectedColorFinish = data.finish_color;
  } else {
    this.useColorFinish      = false;
    this.selectedColorFinish = '';
    if (data.finish_file_manager_id) {
      this.previewUrlFinish = environment.api_domain + '/api/v1/files-view/' + data.finish_file_manager_id + '?v=' + data.updated_at;
    }
  }

  // ===== ส่วนที่เหลือเหมือนเดิม =====
  const effectDateOnly = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
  const expireDateOnly = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('DD-MM-YYYY');
  const effectDate     = moment(data.effect_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');
  const expireDate     = moment(data.expire_date, 'YYYY-MM-DD HH:mm:ss').format('YYYY-MM-DD');

  this.editForm.patchValue({
    id:                data.id,
    name:              data.name,
    description:       data.description,
    effect_expire_date: effectDateOnly + ' - ' + expireDateOnly,
    effect_date:       effectDate,
    expire_date:       expireDate,
    photos_per_payment:       data.photos_per_payment || null,
  });

  this.previewUrl = environment.api_domain + '/api/v1/files-view/' + data.file_manager_id + '?v=' + data.updated_at;
  this.previewIsVideo = data.file_type == 'video';
  // Payment & Print Code & Subscription
  this.editPaymentEnabled = !!data.payment_enabled;
  this.editPrintCodeEnabled = !!data.print_code_enabled;
  this.editPrintCodes = data.print_codes ? data.print_codes.map(pc => ({
    id: pc.id,
    code: pc.code,
    effect_date: pc.effect_date ? pc.effect_date.substring(0, 10) : '',
    expire_date: pc.expire_date ? pc.expire_date.substring(0, 10) : '',
    usage_limit: pc.usage_limit || null,
    usages_count: pc.usages_count || 0
  })) : [];
  this.editSubscriptionEnabled = !!data.subscription_enabled;
  this.editSubscriptionUrl = data.subscription_url || '';
  this.selectedFileSubscriptionEdit = null;
  this.fileNameSubscriptionEdit = 'Choose file';
  this.errorMessageSubscriptionEdit = '';
  this.errorMessageSubscriptionUrlEdit = '';
  this.previewUrlSubscriptionEdit = data.subscription_file_manager_id
    ? environment.api_domain + '/api/v1/files-view/' + data.subscription_file_manager_id + '?v=' + data.updated_at
    : null;
  this.selectedFilePaymentEdit = null;
  this.fileNamePaymentEdit = 'Choose file';
  this.errorMessagePaymentEdit = '';
  this.previewUrlPaymentEdit = data.payment_file_manager_id
    ? environment.api_domain + '/api/v1/files-view/' + data.payment_file_manager_id + '?v=' + data.updated_at
    : null;
  this.showQrPreviewPaymentEdit = false;
  this.showQrPreviewSubscriptionEdit = false;
  if (this.editPaymentEnabled) {
    this.editForm.controls.photos_per_payment.setValidators([Validators.required, Validators.min(1)]);
  } else {
    this.editForm.controls.photos_per_payment.clearValidators();
  }
  this.editForm.controls.photos_per_payment.updateValueAndValidity();

  $('#modal-edit').modal({ backdrop: 'static', keyboard: false }).modal('show');
}

  // ==================== Update ====================
  update() {
    console.log(this.editForm.value);
    this.submitted_edit = true;
    if (this.editForm.invalid) { return; }

    if (this.editPrintCodeEnabled) {
      const err = this.validatePrintCodes(this.editPrintCodes);
      if (err) { this.failDialog(err); return; }
    }

    this.errorMessageSubscriptionUrlEdit = '';
    if (this.editSubscriptionEnabled && this.editSubscriptionUrl) {
      if (!/^https?:\/\//i.test(this.editSubscriptionUrl)) {
        this.errorMessageSubscriptionUrlEdit = 'URL ต้องขึ้นต้นด้วย http:// หรือ https:// เท่านั้น';
        return;
      }
    }

    const formData = new FormData();
    formData.append('id', this.editForm.value.id);
    if (this.selectedFile) {
      formData.append('file', this.selectedFile);
    }
    formData.append('name', this.editForm.value.name);
    formData.append('description', this.editForm.value.description);
    formData.append('effect_date', this.editForm.value.effect_date);
    formData.append('expire_date', this.editForm.value.expire_date);
    formData.append('payment_enabled', this.editPaymentEnabled ? '1' : '0');
    formData.append('print_code_enabled', this.editPrintCodeEnabled ? '1' : '0');
    formData.append('subscription_enabled', this.editSubscriptionEnabled ? '1' : '0');
    if (this.editSubscriptionEnabled) {
      if (this.editSubscriptionUrl) {
        formData.append('subscription_url', this.editSubscriptionUrl);
      }
      if (this.selectedFileSubscriptionEdit) {
        formData.append('file_subscription', this.selectedFileSubscriptionEdit);
      }
    }
    if (this.editPrintCodeEnabled && this.editPrintCodes.length > 0) {
      formData.append('print_codes', JSON.stringify(this.editPrintCodes));
    }
    if (this.editPaymentEnabled) {
      formData.append('photos_per_payment', this.editForm.value.photos_per_payment);
      if (this.selectedFilePaymentEdit) {
        formData.append('file_payment', this.selectedFilePaymentEdit);
      }
    }

    // file_frame_list
    if (this.selectedFileFrameList) {
      formData.append('file_frame_list', this.selectedFileFrameList);
    } else if (this.useColorFrameList && this.selectedColorFrameList) {
      formData.append('file_frame_list_color', this.selectedColorFrameList);
    }

    // file_frame
    if (this.selectedFileFrame) {
      formData.append('file_frame', this.selectedFileFrame);
    } else if (this.useColorFrame && this.selectedColorFrame) {
      formData.append('file_frame_color', this.selectedColorFrame);
    }

    // file_finish
    if (this.selectedFileFinish) {
      formData.append('file_finish', this.selectedFileFinish);
    } else if (this.useColorFinish && this.selectedColorFinish) {
      formData.append('file_finish_color', this.selectedColorFinish);
    }

    this.spinner.show();
    this.eventProjectService.update(formData).subscribe(data => {
      this.submitted_edit = false;
      this.spinner.hide();
      $('#modal-edit').modal('hide');
      this.getAll();
      this.successDialog();
    }, error => {
      console.error(error);
      this.spinner.hide();
      this.failDialog(error.expire_date[0]);
    });
  }

  openDelete(id) {
    this.currentId = id;
    $('#modal-remove').modal('show');
  }

  delete() {
    this.spinner.show();
    this.eventProjectService.delete(this.currentId).subscribe(data => {
      this.spinner.hide();
      $('#modal-remove').modal('hide');
      this.successDialog();
      this.getAll();
    }, error => {
      console.error(error);
      this.spinner.hide();
      this.failDialog('');
    });
  }

  successDialog() {
    Swal.fire("ทำรายการสำเร็จ!", "", "success");
  }

  failDialog(msg) {
    Swal.fire({
      type: 'error',
      title: 'เกิดข้อผิดพลาด',
      text: msg
    });
  }
}